import { Injectable, Output, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { MapsAPILoader, LatLngLiteral, } from '@agm/core';

import { BaseWebApiService } from './base-web-api-service';
import { GeoData } from '../models';

@Injectable()
export class GoogleGeoService {

    private error: GeoData = new GeoData({});
    mapsApiReady: boolean = false;

    @Output() onMapsApiReady = new EventEmitter();
    constructor(private baseWebApiService: BaseWebApiService, private http: Http, private mapsAPILoader: MapsAPILoader) {
        this.mapsAPILoader.load().then(() => {
            this.mapsApiReady = true;
            this.onMapsApiReady.emit();
        });
    }

    geocodeAddress(address: string): Promise<GeoData> {
        if (!address || address.trim() == "") {
            this.baseWebApiService.asyncErrorStatusChange(true, "Errore GoogleGeoService: parametro address mancante.");
            return Promise.resolve(this.error);
        }
        return this.geoCode({ address: address });
    }

    geocodeCoordinates(lat: number, lon: number): Promise<GeoData> {
        if (!lat || !lon) {
            this.baseWebApiService.asyncErrorStatusChange(true, "Errore GoogleGeoService: parametri lat e/o lon mancanti.");
            return Promise.resolve(this.error);
        }
        let latLng: LatLngLiteral = {
            lat: lat,
            lng: lon
        };
        return this.geoCode({ location: latLng });
    }

    geocodePlaceId(placeId: string): Promise<GeoData> {
        if (!placeId || placeId.trim() == "") {
            this.baseWebApiService.asyncErrorStatusChange(true, "Errore GoogleGeoService: parametro placeId mancante.");
            return Promise.resolve(this.error);
        }
        return this.geoCode({ placeId: placeId });
    }

    geoCode(param: any): Promise<GeoData> {
        return Observable.create(observer => {
            let geoCoder = new google.maps.Geocoder();
            geoCoder.geocode(param, function (results, status) {
                observer.next({ status: status, results: results });
                observer.complete();
            })
        }).toPromise()
            .then(response => {
                if (response.status != "OK") {
                    this.baseWebApiService.asyncErrorStatusChange(true, "Errore GoogleGeoService: " + response.status);
                }
                let data: GeoData = new GeoData(response.results[0]);
                return Promise.resolve(data);
            })
            .catch(error => {
                this.baseWebApiService.asyncErrorStatusChange(true, "Errore GoogleGeoService.");
                return Promise.resolve(new GeoData({}));
            });
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/services/google-geo.service.ts